import React from 'react';

import SpinnerBlock from '../../../common/SpinnerBlock';
import Editable from '../../../common/Editable';

const MobileTable = (props) => {
  const {
    data,
    creatable,
    bottomCreateButton,
    removable,
    createLabel,
    handleRemoveItem = () => false,
    handleNewItem,
    loading,
    TableWrap,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    isNew,
  } = props;

  return (
    <>
      <SpinnerBlock show={loading} />
      <TableWrap>
        {data &&
          data.map((item, i) => (
            <div className="table-row" key={item.id}>
              <div className="right">
                <div className="img">
                  <img src={item?.images?.[0].url ?? ''} alt="" />
                </div>
                <div className="main">
                  <div className="table-item-title">{item.shortName}</div>
                  <div className="table-item-art">Арт.: {item.article}</div>
                  <div className="table-item-id">{item.id}</div>
                  <div className="table-item-quantity">
                    Количество:
                    {isNew ? (
                      <span>{item.quantity}</span>
                    ) : (
                      <Editable
                        value={
                          currentQuantityInput === item.id
                            ? currentQuantityInputValue
                            : item.quantity
                        }
                        currentInput={currentQuantityInput === item.id}
                        toggleInput={() => handleToggleQuantityInput(item)}
                        handleUpdate={() => handleUpdateQuantity(currentQuantityInputValue, i)}
                        onChange={(e) => setCurrentQuantityInputValue(e.target.value)}
                        handleCancel={() => setCurrentQuantityInput(null)}
                      />
                    )}
                    шт.
                  </div>
                  <div className="table-item-quantity">Остаток: {item.stockAvailable} шт.</div>
                </div>
              </div>
              <div className="left">
                <div className="table-action">
                  {removable ? (
                    <div className="item-remove" onClick={() => handleRemoveItem(data, i)}>
                      <i className="fe-trash-2" />
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
              </div>
            </div>
          ))}
      </TableWrap>
      {creatable && bottomCreateButton ? (
        <div
          style={{ color: '#7e57c2', cursor: 'pointer', marginBottom: '15px', marginTop: '15px' }}
          onClick={handleNewItem}
        >
          {createLabel}
        </div>
      ) : null}
    </>
  );
};

export default MobileTable;
